'use client';

import { Log, UserManager, WebStorageStateStore } from 'oidc-client-ts';

declare global {
    var __OIDC_USER_MANAGER__: UserManager | undefined;
    var __OIDC_LOG_INIT__: boolean | undefined;
}

function createUserManager(): UserManager {
    if (typeof window === 'undefined') {
        throw new Error('UserManager must only be used in the browser');
    }

    if (!globalThis.__OIDC_LOG_INIT__) {
        Log.setLogger(console);
        Log.setLevel(
            process.env.NEXT_PUBLIC_ENV === 'localhost' && process.env.NEXT_PUBLIC_DEBUG === 'true'
                ? Log.DEBUG
                : Log.NONE,
        );
        globalThis.__OIDC_LOG_INIT__ = true;
    }

    const mgr = new UserManager({
        authority: process.env.NEXT_PUBLIC_OIDC_AUTHORITY as string,
        client_id: process.env.NEXT_PUBLIC_OIDC_CLIENT_ID as string,
        redirect_uri: process.env.NEXT_PUBLIC_OIDC_REDIRECT_URI as string,
        response_type: 'code',
        scope: 'openid profile email',
        post_logout_redirect_uri: process.env.NEXT_PUBLIC_OIDC_POST_LOGOUT_URI as string,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        stateStore: new WebStorageStateStore({ store: window.localStorage }),
        automaticSilentRenew: true,
        silent_redirect_uri: process.env.NEXT_PUBLIC_OIDC_SILENT_REDIRECT_URI as string,
    });

    return mgr;
}

export function getUserManager(): UserManager {
    if (globalThis.__OIDC_USER_MANAGER__) {
        return globalThis.__OIDC_USER_MANAGER__;
    }
    const mgr = createUserManager();
    globalThis.__OIDC_USER_MANAGER__ = mgr;
    return mgr;
}
